import { createSlice } from '@reduxjs/toolkit';
import { loginUserAction, logoutUserAction, setAccessTokenAction, setCapsAction, setRolesAction } from '../actions/UsersActions';

export const UserSlice = createSlice({
	name: 'user',
	initialState: {
		isLoggedin: false,
		userData: {},
		accessToken: "",
		capsList: [],
		rolesList: [],
		loggingOut:false
	},
	reducers: {
		setLogin: loginUserAction,
		logoutUser: logoutUserAction,
		setAccessToken: setAccessTokenAction,
		setRolesList: setRolesAction,
		setCapsList: setCapsAction
	}
});
export const { setLogin, logoutUser, setAccessToken, setRolesList, setCapsList } = UserSlice.actions
export default UserSlice.reducer;